
      import { initializePrivacyCompliance } from '/src/privacy-compliance.ts';
      import { mountDsrForm } from '/src/privacy-dsr-form.ts';

      initializePrivacyCompliance();
      mountDsrForm();
    